import React from 'react';
import { Field } from 'redux-form';
import { Grid } from 'semantic-ui-react';
import PropTypes from 'prop-types';

import { VendorFieldEnum as Fields } from 'Common/FieldEnum';
import { InputField, CheckboxField } from 'Common/SemanticWrapper';
import { InputMode } from 'Common/FormEnum';
import StateDropdown from 'Common/Components/StateDropdown/StateDropdown';
import { normalizePhone, normalizeZip4 } from 'Common/FormHelper';

export const VendorInfoFields = ({
  formValues,
  setSameAsPOAddress,
  IsPOAddSameAsRemittance,
  handleChangeOfPOAddress,
}) => {
  return (
    <Grid>
      <Grid.Row columns={3}>
        <Grid.Column>
          <Field
            component={InputField}
            label={'Distributor Id'}
            maxLength={20}
            name={Fields.VendorNum}
            disabled={formValues.Id != null}
          />
        </Grid.Column>
        <Grid.Column>
          <Field
            component={InputField}
            label={'Federal Id'}
            maxLength={11}
            name={Fields.FederalId}
          />
        </Grid.Column>
        <Grid.Column>
          <Field
            component={InputField}
            label={'Distributor Name'}
            maxLength={30}
            name={Fields.Description}
          />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row columns={1}>
        <Grid.Column>
          <label className={'text-orange'}>Purchase Order Address</label>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row columns={2}>
        <Grid.Column>
          <Field
            name={Fields.POAddress1}
            component={InputField}
            type="text"
            label={'Address 1'}
            maxLength={30}
            onChange={handleChangeOfPOAddress}
          />
        </Grid.Column>
        <Grid.Column>
          <Field
            name={Fields.POAddress2}
            component={InputField}
            type="text"
            label={'Address 2'}
            maxLength={30}
            onChange={handleChangeOfPOAddress}
          />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row columns={3}>
        <Grid.Column>
          <Field
            name={Fields.POCity}
            component={InputField}
            type="text"
            label={'City'}
            maxLength={20}
            onChange={handleChangeOfPOAddress}
          />
        </Grid.Column>
        <Grid.Column>
          <StateDropdown
            name={Fields.POState}
            upward
            onChange={handleChangeOfPOAddress}
          />
        </Grid.Column>
        <Grid.Column>
          <Field
            name={Fields.POZip}
            component={InputField}
            type="text"
            label={'Zip +4'}
            maxLength={10}
            mode={InputMode.Integer}
            onChange={handleChangeOfPOAddress}
            normalize={normalizeZip4}
          />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row columns={3}>
        <Grid.Column>
          <Field
            name={Fields.POPhone}
            component={InputField}
            type="text"
            label={'Phone'}
            maxLength={14}
            mode={InputMode.Integer}
            normalize={normalizePhone}
            onChange={handleChangeOfPOAddress}
          />
        </Grid.Column>
        <Grid.Column>
          <Field
            name={Fields.POFax}
            component={InputField}
            type="text"
            label={'Fax'}
            maxLength={14}
            mode={InputMode.Integer}
            normalize={normalizePhone}
          />
        </Grid.Column>
        <Grid.Column>
          <Field
            name={Fields.POEmail}
            component={InputField}
            type="text"
            label={'Email'}
            maxLength={30}
          />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row columns={2}>
        <Grid.Column>
          <label className={'text-orange'}>Remittance Address</label>
        </Grid.Column>
        <Grid.Column>
          <Field
            name={Fields.IsPOAddSameAsRemittance}
            component={CheckboxField}
            label={'Same as Purchase Order Address'}
            onChange={setSameAsPOAddress}
            style={{ paddingTop: 14 }}
          />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row columns={2}>
        <Grid.Column>
          <Field
            name={Fields.RemitAddress1}
            component={InputField}
            type="text"
            label={'Address 1'}
            maxLength={30}
            disabled={IsPOAddSameAsRemittance}
          />
        </Grid.Column>
        <Grid.Column>
          <Field
            name={Fields.RemitAddress2}
            component={InputField}
            type="text"
            label={'Address 2'}
            maxLength={30}
            disabled={IsPOAddSameAsRemittance}
          />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row columns={3}>
        <Grid.Column>
          <Field
            name={Fields.RemitCity}
            component={InputField}
            type="text"
            label={'City'}
            maxLength={20}
            disabled={IsPOAddSameAsRemittance}
          />
        </Grid.Column>
        <Grid.Column>
          <StateDropdown
            name={Fields.RemitState}
            upward
            disabled={IsPOAddSameAsRemittance}
          />
        </Grid.Column>
        <Grid.Column>
          <Field
            name={Fields.RemitZip}
            component={InputField}
            type="text"
            label={'Zip +4'}
            maxLength={10}
            mode={InputMode.Integer}
            disabled={IsPOAddSameAsRemittance}
            normalize={normalizeZip4}
          />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row columns={3}>
        <Grid.Column>
          <Field
            name={Fields.RemitPhone}
            component={InputField}
            type="text"
            label={'Phone'}
            maxLength={14}
            mode={InputMode.Integer}
            normalize={normalizePhone}
            disabled={IsPOAddSameAsRemittance}
          />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row columns={3}>
        <Grid.Column verticalAlign={'bottom'}>
          <Field
            name={Fields.Display}
            component={CheckboxField}
            label={'Display'}
          />
        </Grid.Column>
        <Grid.Column verticalAlign={'bottom'}>
          <Field
            name={Fields.IsWarehouseOrKitchen}
            component={CheckboxField}
            label={'Warehouse/Kitchen'}
          />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

VendorInfoFields.propTypes = {
  formValues: PropTypes.object.isRequired,
  setSameAsPOAddress: PropTypes.func,
  IsPOAddSameAsRemittance: PropTypes.bool,
  handleChangeOfPOAddress: PropTypes.func,
};

VendorInfoFields.defaultProps = {
  setSameAsPOAddress: () => {},
  IsPOAddSameAsRemittance: false,
  handleChangeOfPOAddress: () => {},
};



// WEBPACK FOOTER //
// ./src/pages/inventory/vendorsetup/components/VendorInfoFields.js